import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderSummaryResponse } from '../components/model/ordersummaryresponse';
import { AppConstants } from '../constants/app.constants';
import { SAVER, Saver } from '../components/model/saver'
import { download, Download } from '../components/model/download'
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';
  constructor(private httpClient: HttpClient, @Inject(SAVER) private save: Saver) { }

  

  public async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('data');
    const columnKeys: string[] = [];
    (json || []).forEach(row => {
      Object.keys(row || {}).forEach(key => {
        if (!columnKeys.includes(key)) {
          columnKeys.push(key);
        }
      });
    });
    worksheet.columns = columnKeys.map(key => ({ header: key, key }));
    worksheet.addRows(json || []);
    const excelBuffer = await workbook.xlsx.writeBuffer();
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName);
  }

  getSignedResults(repeportRequest: any, fromDate: string, toDate: string):
    Observable<OrderSummaryResponse[]> {
     
    return this.httpClient.get<OrderSummaryResponse[]>
      (AppConstants.GET_SINGED_ORDERS
        + "?fromDate=" + fromDate + "&toDate=" + toDate + "&dcLocation=" + repeportRequest.dcNumber
        + "&storeNumber=" + repeportRequest.storeNumber
        + "&eSignedBy=" + repeportRequest.signedBy
        + "&poNumber=" + repeportRequest.orderNumber);

  }



  getMarReport(dcLocation:any,fromDate: string, toDate: string):Observable<any> {

    return this.httpClient.get(AppConstants.GET_MAR_REPORT
        + "?fromDate=" + fromDate + "&toDate=" + toDate+ "&dcLocation=" + dcLocation,{
          responseType: 'arraybuffer',observe: 'response'
        });

  }

  getMSRReport(msrRequest:any,fromDate: string, toDate: string):Observable<any> {

    return this.httpClient.get(AppConstants.GET_MSR_REPORT
        + "?overdue=" + msrRequest.overdue + "&late=" + msrRequest.late+"&fromDate=" + fromDate + "&toDate="+ toDate
        +"&dcLocation=" + msrRequest.dcNumber,{
          responseType: 'arraybuffer',observe: 'response'
        });

  }

  getExceptionReport(sequenceNumber):Observable<any> {

    return this.httpClient.get(AppConstants.GET_EXCEPTION_REPORT
        + "?sequenceNumber=" + sequenceNumber,{
          responseType: 'arraybuffer',observe: 'response'
        });

  }


  getExceptionResults(exRequest:any,fromDate: string, toDate: string):Observable<any> {

    return this.httpClient.get(AppConstants.GET_EXCEPTION_RESULTS
        + "?fromDate=" + fromDate + "&toDate="+ toDate
        +"&dcLocation=" + exRequest.dcNumber + "&storeNumber=" + exRequest.storeNumber);

  }


 
  // getESAResultsReport(exRequest: any, fromDate: string, toDate: string): Observable<any> {

  //   return this.httpClient.get(AppConstants.GET_ESA_RESULTS_REPORT+"?fromDate=" + fromDate + "&toDate=" + toDate
  //     + "&attestedBy=" + exRequest.signedBy + "&dcLocation=" + exRequest.dcNumber + "&storeNumber=" + exRequest.storeNumber
  //     , {
  //       responseType: 'arraybuffer', observe: 'response'
  //     });

  // }

  getESAResultsReport(exRequest: any, fromDate: string, toDate: string):Observable<any> {
    return this.httpClient.get(AppConstants.GET_ESA_RESULTS_REPORT + "?fromDate="+fromDate+"&toDate="+toDate+"&dcLocation="+exRequest.dcNumber+"&storeNumber="+ exRequest.storeNumber, {
      responseType: 'arraybuffer',observe: 'response'
    })
  }
  getSignedResultsReports(sequenceNumber):Observable<any> {
    return this.httpClient.get(AppConstants.GET_SINGED_ORDERS_REPORT + "?sequenceNumber=" + encodeURIComponent(sequenceNumber), {
      responseType: 'arraybuffer',observe: 'response'
    })
  }


  public getUnSignedPackagesReport():Observable<any> {
    return this.httpClient.get(AppConstants.GET_UNSINGED_PACKAGES_REPORT, {
      responseType: 'arraybuffer',observe: 'response'
    })
  }
  public getUnSignedPackagesReport1() {
    return this.httpClient.get(AppConstants.GET_UNSINGED_PACKAGES_REPORT, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }).pipe(download(blob => this.save(blob, "test.xlsx")))
  }
}
